const Vue = require('vue');

/**
 * ValidateSimulationElectricityUsage
 * @class
 */
class ValidateSimulationElectricityUsage {

  /**
   * @instance
   * @private
   */
  get ERROR_TEXT() {
    return {
      brank: '入力してください',
      kwh  : '1から99,999までの整数で入力してください',
    }
  }

  /**
   * @instance
   * @param el {string|HTMLElement} element
   */
  constructor(el) {
    this.vm = new Vue({
      el: el,
      data: {
        val: {
          kwh: '',
        },
        validate: {
          kwh: false,
        },
        err: {
          kwh: null,
        },
        isCorrect: false,
      },
      components: {
        'efo': {
          props: ['err'],
          template: '#efo-tmp',
        },
      },
      methods: {
        validateKwh: () => {
          setTimeout(() => {
            this.vdKwh(this.vm.val.kwh);
          }, 100);
        },
        submit: (e) => {
          e.preventDefault();
          this.vdAll();
          setTimeout(() => {
            if(this.vm.isCorrect) {
              simulation.run();
            }
          }, 0);
        },
      },
    });

    this.vm.$watch('validate', () => {
      this.setIsCorrect();
    }, { deep: true });

    this.setIsCorrect();
  }

  /**
   * @instance
   * @private
   */
  vdAll() {
    this.vdKwh(this.vm.val.kwh);
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  vdKwh(val) {
    if(!this.validateRequired(val)) {
      this.vm.err.kwh = this.ERROR_TEXT.brank;
      this.vm.validate.kwh = false;
      return;
    }
    let _val = this.toNumHalf(val);
    _val = this.toComma(_val);
    this.vm.val.kwh = _val;
    if(!this.validateNumInteger(_val) || !this.validateNumRenge(_val, 1, 99999)) {
      this.vm.err.kwh = this.ERROR_TEXT.kwh;
      this.vm.validate.kwh = false;
      return;
    }
    this.vm.err.kwh = null;
    this.vm.validate.kwh = true;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateRequired(val) {
    return (val !== '') ? true : false;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateNumInteger(val) {
    return val.match(/^[0-9]+?,?[0-9]*$/) ? true : false;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   * @param min {integer}
   * @param max {integer}
   */
  validateNumRenge(val, min, max) {
    const num = Number(val.replace(/,/g, ''));
    return ((min <= num) && (num <= max)) ? true : false;
  }


  /**
   * @instance
   * @private
   * @param str {string}
   */
  toNumHalf(str) {
    return str.replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  }

  /**
   * @instance
   * @private
   * @param str {string}
   */
  toComma(str) {
    return str.replace(/,/g, '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }

  /**
   * @instance
   * @private
   */
  setIsCorrect() {
    const vd = this.vm.validate;

    if(vd.kwh) {
      this.vm.isCorrect = true;
    } else {
      this.vm.isCorrect = false;
    }
  }

}

/**
 * class exports
 */
module.exports = ValidateSimulationElectricityUsage;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/form/validate-simulation-electricity-usage.js
 **/